import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export interface MarkdownWrapperProps {
  children: string;
  extraClass?: string;
}

export default function MarkdownWrapper({
  children,
  extraClass,
}: MarkdownWrapperProps) {
  return (
    <Markdown
      remarkPlugins={[remarkGfm]}
      className={`prose ${extraClass}`}
      components={{
        // overwrite links to open in new tabs
        a: ({ children, target, ...others }) => (
          <a {...others} target="_blank">
            {children}
          </a>
        ),
      }}
    >
      {children}
    </Markdown>
  );
}
